import { gql } from "@apollo/client";

export const FETCH_QUESTIONS_BY_VIDEO_ID = gql`
 query FetchQuestionsByVideoId($video_id: UUID!) {
    fetchQuestionsByVideoId(video_id: $video_id) {
        data {
            questions {
                created_at
                id
                is_published
                question
                updated_at
                video_id
                options {
                    created_at
                    id
                    is_correct_answer
                    option
                    updated_at
                    video_question_id
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;
